import moment from "moment";
import { Button } from "../../../../Common/AbstractComponents/Button";
import AjaxBuilder from "../../../../Common/AjaxBuilder";
import { Util } from "../../../../Common/Util";
import Vocabulary from "../../../../Common/Vocabulary";
import { AlertMessage } from "../../../CommonComponents/Insurance/AlertMessage";
import { Loader } from '../../../CommonComponents/Insurance/Loader';

export class ContinueBtn {
    constructor({ insuranceForm, state }) {
        this.$insuranceForm = insuranceForm;
        this._state = state;
        this._lang = $('html').attr('lang');

        this.$submitButton = $(this.$insuranceForm).find('#continue_btn');
        
        this._button = new Button({
            button: this.$submitButton,
            onClick: this._costCalculation.bind(this),
        });

    }


    _costCalculation(event) {
        event.preventDefault();

        if (!this._state.country) {
            AlertMessage.showMessage(Vocabulary[this._lang].errors.country);
            return;
        }

        const duration = moment.duration(this._state.end.diff(this._state.start));

        if (duration.asDays() <= 0) {
            AlertMessage.showMessage(Vocabulary[this._lang].errors['duration_date-error']);
            return;
        }
        
        Loader.showLoader(this.$insuranceForm);
        
        const data = {
            "country": this._state.country,
            "days": this._state.days,
            "is_multivisa": this._state.is_multivisa,
            "risk": this._state.risk,
            "start": this._state.start.format('DD.MM.yyyy'),
            "end": this._state.end.format('DD.MM.yyyy'),
            "covid_plus": this._state.covid_plus,
            "clients": this._state.clients.map(client => {return {
                "born_date": client.born_date.format('DD.MM.yyyy'),
                "mz_insurance_sum": client.mz_insurance_sum
            }}),
        };

        if (this._state.country.is_group) {
            data.currency = this._state.currency;
        }

        new AjaxBuilder({
            route: $(this.$insuranceForm).data('save-cart'),
            data,
            token: Util.token(),
        }, 'POST').execute({
            success: (data) =>{
                Loader.hideLoader(this.$insuranceForm);
                window.location = this.$insuranceForm.data('checkout');
            },
            error: (error) => {
                console.log(error);
                AlertMessage.showMessage(error.responseJSON.message);
                Loader.hideLoader(this.$insuranceForm);
            }
        });
    }

}